
export function InsertHTMLOnCaretPosition(html){
  // return document.execCommand("insertHTML", true, html);
  let selection = window.getSelection();
  if(selection !== null){
      if(selection.rangeCount > 0){
          let range = selection.getRangeAt(0);
          
          var div = document.createElement("div");
          div.innerHTML = html;
          let toInsert = div.firstChild;

          range.insertNode(toInsert);

          range.collapse(false);
          selection.collapseToEnd();
          return true;
      }
  }
  return false;
}